import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const ReviewEditForm = ({ 
  formData, 
  errors, 
  handleChange, 
  handleRatingChange, 
  handleStatusChange, 
  boats 
}) => {
  const renderStars = (rating, interactive = false, onStarClick = null) => {
    return Array.from({ length: 5 }, (_, index) => {
      const starValue = index + 1;
      const isFilled = starValue <= rating;
      
      return (
        <FontAwesomeIcon
          key={index}
          icon={faStar}
          className={`star ${interactive ? 'interactive' : ''} ${isFilled ? 'filled' : 'empty'}`}
          onClick={interactive ? () => onStarClick(starValue) : undefined}
          style={{ cursor: interactive ? 'pointer' : 'default' }}
        />
      );
    });
  };

  const getCurrentStatus = () => {
    return formData.isApproved ? 'approved' : 'rejected';
  };

  return (
    <div className="form">
      <div className="form-group-row">
        <div className="form-group">
          <input
            type="text"
            name="reviewerName"
            value={formData.reviewerName}
            onChange={handleChange}
            placeholder="Reviewer Name*"
            className={errors.reviewerName ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.reviewerName}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email*"
            className={errors.email ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.email}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <select
            name="boat_id"
            value={formData.boat_id}
            onChange={handleChange}
            className={errors.boat_id ? 'error' : ''}
          >
            <option value="">Select Boat*</option>
            {boats.map(boat => (
              <option key={boat.id} value={boat.id}>
                {boat.name}
              </option>
            ))}
          </select>
          <div className="error-message-container">
            <p className="error-message">{errors.boat_id}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <div className="rating-input">
            <span>Rating*</span>
            <div className="stars-container">
              {renderStars(formData.rating, true, handleRatingChange)}
              <span className="rating-text">({formData.rating} stars)</span>
            </div>
          </div>
          <div className="error-message-container">
            <p className="error-message">{errors.rating}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <textarea
            name="comment"
            value={formData.comment}
            onChange={handleChange}
            placeholder="Comment*"
            className={errors.comment ? 'error' : ''}
            maxLength="300"
          />
          <div className="character-count">
            {formData.comment.length}/300 characters
          </div>
          <div className="error-message-container">
            <p className="error-message">{errors.comment}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <select
            name="status"
            value={getCurrentStatus()}
            onChange={handleStatusChange}
            className={errors.status ? 'error' : ''}
          >
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
          <div className="error-message-container">
            <p className="error-message">{errors.status}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewEditForm; 